<template>
  <div>
    <van-sticky>
      <nav-bar class="home-nav">
        <div slot="left" @click="onClickLeft">返回</div>
        <div slot="center">体测成绩列表({{ countStu }})</div>
      </nav-bar>

      <van-search
        v-model="searchValue"
        show-action
        placeholder="请输入姓名或学号关键词"
        @search="onSearch"
        @cancel="onCancel"
      />
    </van-sticky>

    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
        loading-text="努力加载中"
      >
        <van-swipe-cell v-for="(item,index) in studentList" :key="item.id">
          <!--        <template slot="left">-->
          <!--          <van-button square type="primary" text="选择"/>-->
          <!--        </template>-->
          <van-cell :border="false"
                    :value="item.snum">
            <template #title>
            <span class="custom-title">{{
                '(' + ((currentPage - 1) * 10 + (index + 1)) + ') ' + item.sname + ' ' + item.gender + ' '
              }}</span>
              <van-tag type="success">{{ item.years }}</van-tag>
            </template>
          </van-cell>
          <template slot="right">
            <van-button square type="primary" @click="detail(item.id)" text="详细"/>
          </template>

        </van-swipe-cell>
      </van-list>
    </van-pull-refresh>

    <!--    分页-->
    <van-pagination
      v-model="currentPage"
      :total-items="125"
      :page-count="pageCount"
      :show-page-size="5"
      force-ellipses
      @change="onPageChange"
      style="bottom: 0;position: fixed; width: 100%;padding-top: 20px"
    />

    <van-action-sheet v-model="detailShow" :title="info.sname">
      <div style="margin-top: 50px;margin-bottom: 50px">
        <van-cell title="测试年度" :value="info.years"/>
        <van-cell title="总成绩" :value="info.total"/>
        <van-cell title="综合评价" :value="info.ranks"/>
        <van-grid column-num="3" icon-size="40">
          <van-grid-item icon="http://icon.hhstu.club/%E6%80%A7%E5%88%AB.png" :text="'\n性别:'+info.gender"/>
          <van-grid-item
            icon="http://icon.hhstu.club/%E6%88%91%E7%9A%84%E5%AE%9D%E8%B4%9D%E9%A1%B5_%E8%BA%AB%E9%AB%98.png"
            :text="'身高:'+info.hwScore+'分'+'\n'+info.height+'(cm)'"/>
          <van-grid-item icon="http://icon.hhstu.club/%E4%BD%93%E9%87%8D.png"
                         :text="'体重:'+info.hwScore+'分'+'\n'+info.weight+'(kg)'"/>
          <van-grid-item icon="http://icon.hhstu.club/%E8%82%BA%E6%B4%BB%E9%87%8F.png"
                         :text="'肺活量:'+info.vcScore+'分'+'\n'+info.vitalCapacity+'(ml)'"/>
          <van-grid-item icon="http://icon.hhstu.club/%E8%B7%91%E6%AD%A5%20%281%29.png"
                         :text="'50米跑:'+info.fmScore+'分'+'\n'+info.fm+'(秒)'"/>

          <van-grid-item icon="http://icon.hhstu.club/%E8%B7%B3%E8%BF%9C.png"
                         :text="'立定跳远:'+info.sjScore+'分'+'\n'+info.sj+'(cm)'"/>
          <van-grid-item icon="http://icon.hhstu.club/%E6%94%AF%E5%BA%A7%E4%BD%8D%E7%A7%BB.png"
                         :text="'坐位体前屈:'+info.sfbScore+'分'+'\n'+info.sfb+'(cm)'"/>
          <van-grid-item v-if="info.gender=='男'" icon="http://icon.hhstu.club/%E8%B7%91%E6%AD%A5%20%282%29.png"
                         :text="'1000米跑:'+info.eokScore+'分'+'\n'+info.ok+'(分)'"/>
          <van-grid-item v-else icon="http://icon.hhstu.club/%E8%B7%91%E6%AD%A5%20%282%29.png"
                         :text="'800米跑:'+info.eokScore+'分'+'\n'+info.ehm+'(分)'"/>
          <van-grid-item v-if="info.gender=='男'"
                         icon="http://icon.hhstu.club/%E5%BC%95%E4%BD%93%E5%90%91%E4%B8%8A2%402x.png"
                         :text="'引体向上:'+info.spScore+'分'+'\n'+info.pu+'(个)'"/>
          <van-grid-item wx:else icon="http://icon.hhstu.club/%E4%BB%B0%E5%8D%A7%E8%B5%B7%E5%9D%902%402x.png"
                         :text="'仰卧起坐:'+info.spScore+'分'+'\n'+info.su+'(个)'"/>
        </van-grid>
      </div>
    </van-action-sheet>

  </div>
</template>

<script>
import Vue from 'vue';
import {
  Cell, Search, List, SwipeCell, Button, Dialog, Toast, Sticky, PullRefresh, Pagination, Tag,
  ActionSheet, Switch, Form, Field, Popup, Grid, GridItem
} from 'vant';
import NavBar from "components/common/navbar/NavBar";
import {
  GetPhysicalTestListLikeKeyByPage,
  GetPhysicalTestCountByKey,
  GetPhysicalTestInfoById,
} from "../../../network/physical_test";

Vue.use(Cell)
Vue.use(Search)
Vue.use(List)
Vue.use(SwipeCell)
Vue.use(Button)
Vue.use(Dialog)
Vue.use(Toast)
Vue.use(Sticky)
Vue.use(PullRefresh)
Vue.use(Pagination)
Vue.use(Tag)
Vue.use(ActionSheet)
Vue.use(Switch)
Vue.use(Form)
Vue.use(Field)
Vue.use(Popup)
Vue.use(Grid)
Vue.use(GridItem)
export default {
  name: "PhysicalTestList",
  components: {
    NavBar
  },
  data() {
    return {
      studentList: [],
      searchValue: '',
      countStu: 0,

      //refresh
      refreshing: false,
      loading: false,
      finished: true,

      //分页
      currentPage: 0,

      //action sheet
      detailShow: false,
      info: {}

    }
  },
  mounted() {
    this.getPhysicalTestCountByKey(this.searchValue);
    this.getPhysicalTestListLikeKeyByPage("");
  },
  computed: {
    pageCount() {
      if (this.countStu % 10 === 0)
        return this.countStu / 10;
      return parseInt(this.countStu / 10) + 1;
    },
  },
  methods: {
    //refresh
    onLoad() {
      setTimeout(() => {
        this.refreshing = false;
        Toast('刷新成功');
      }, 1500);
    },
    onRefresh() {
      // 清空列表数据;
      this.studentList = [];
      // 将 loading 设置为 true，表示处于加载状态
      //this.loading = true;
      this.onLoad();
      setTimeout(() => {
        // 重新加载数据
        this.getPhysicalTestCountByKey(this.searchValue);
        this.getPhysicalTestListLikeKeyByPage(this.searchValue);
        this.isLoading = false;
      }, 1000);
    },
    onSearch(val) {
      this.getPhysicalTestListLikeKeyByPage(this.searchValue);
      this.getPhysicalTestCountByKey(this.searchValue);
    },
    onCancel() {
      this.getPhysicalTestListLikeKeyByPage("");
      this.getPhysicalTestCountByKey();
    },
    onPageChange() {
      this.getPhysicalTestListLikeKeyByPage(this.searchValue, this.currentPage);
    },
    getPhysicalTestListLikeKeyByPage(name, page = 1) {
      GetPhysicalTestListLikeKeyByPage(name, page).then(res => {
        this.studentList = res;
      });
    },
    getPhysicalTestCountByKey(key = "") {
      GetPhysicalTestCountByKey(key).then(res => {
        this.countStu = res;
      });
    },
    formatDate(date) {
      return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()} ${date.getHours()}:${date.getMinutes()}`;
    },
    detail(id) {
      this.detailShow = true;
      GetPhysicalTestInfoById(id).then(res => {
        this.info = res.info;
      })


    },
    onClickLeft() {
      // this.$router.back(-1);
      this.$router.replace("/more");
    },
  }
}
</script>

<style scoped>
.home-nav {
  background-color: var(--color-tint);
  color: #fff;
}
</style>
